import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Base64UrlService } from '../../../services/base64url.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinessItem, LogisticService } from '../../../services/logistic.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
    selector: 'tt-br-reg-view',
    templateUrl: './br-reg-view.component.html',
    styleUrls: ['./br-reg-view.component.css'],
    standalone: false
})
export class BrRegViewComponent implements OnInit {
    orgNo;

    resourceId;

    public customerGroupButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'custgrps' }];

    public customerBusinessButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'businesss' }];

    public edit?: Edit;

    public selectListCustomerGroups: CustomerGroupItem[] = [];

    public selectListBusinesses: BusinessItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private base64: Base64UrlService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.orgNo = this.stateService.getStateParams()['orgno'];
        this.resourceId = this.stateService.getStateParams()['resource_id'];
    }

    private async loadOrganizationNumbers() {
        const organizationUrl = 'https://data.brreg.no/enhetsregisteret/api/enheter?organisasjonsnummer=' + this.orgNo;

        const response = await fetch(organizationUrl);

        if (!response.ok) {
            throw new Error(`HTTP error: ${response.status}`);
        }

        const responseText = await response.text();

        this.edit = (await this.datatask.Post(1310, {
            response: this.base64.urlEncode(responseText), 
            resource_id: this.resourceId
        }))[0];
    }

    private async loadCustomerGroups() {
        this.selectListCustomerGroups = await this.datatask.Post(69, { add_all: '0' });
    }

    private async loadBusinesses() {
        this.selectListBusinesses = await this.logistic.getBusinesses();
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1311, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async openWebLink() {
        let proffNo = 'https://www.proff.no/bransjesøk?q=' + this.orgNo;
        window.open(proffNo);
    }

    private async init() {
        this.loadOrganizationNumbers();
        this.loadCustomerGroups();
        this.loadBusinesses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    cust_name: string;
    cust_adr_street: string;
    postplace_id_street: string;
    org_no: string;
    nace_code: string;
    nace_description: string;
    custgrp_id: string;
    cust_business_id: string;
    sr: string;
    resource_id: string;
}

interface CustomerGroupItem {
    custgrp_id: string;
    custgrp_name: string;
    orderby: number;
}
